import { z } from "zod";
import { confirmableConfig, confirmableDefaults } from "./confirmable.js";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({ ...confirmableConfig });

export const websiteField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "website",
  label: "Website",
  category: "basic_info",
  icon: "Link",
  configSchema,
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(z.string().trim().url("Enter a valid URL"), isRequired),
  defaultConfig: { ...confirmableDefaults },
  supportsProfileBinding: true,
  defaultSearchable: false,
  renderHints: {},
};
